// Keep staff navigation separate from backend API addresses. This obscures the
// portal entry point; authentication, MFA and the network policy enforce access.
export const STAFF_PORTAL_BASE = '/entry-415bf38bafb184260d6f41ef6874af4d';
export const STAFF_PATHS = Object.freeze({
  root: STAFF_PORTAL_BASE,
  login: `${STAFF_PORTAL_BASE}/login`,
  dashboard: `${STAFF_PORTAL_BASE}/dashboard`,
  marketing: `${STAFF_PORTAL_BASE}/marketing`,
  team: `${STAFF_PORTAL_BASE}/team`,
  settings: `${STAFF_PORTAL_BASE}/settings`,
});
export const isStaffPortalPath = pathname => pathname === STAFF_PORTAL_BASE || pathname.startsWith(`${STAFF_PORTAL_BASE}/`);
